<div class="st-drawer-wrapper">
  <a href=""></a>
  <div class="st-drawer-header lg-p-x show-border">
    <span class="text-header-18 text-semibold">Asignar equipos</span>
    <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
  </div>

  <div class="st-drawer-content">
    <app-equipment-table *ngIf="!loading" (selectedEquipmentsEvent)="selectedEquipmentChange($event)"
                         [isServiceOrder]="!!serviceOrder"
                         [isAsigning]="true"
                         [equipments]="equipmentsToAsign"></app-equipment-table>
    <nz-skeleton *ngIf="loading" [nzParagraph]="{ rows: 6 }" [nzActive]="true"></nz-skeleton>
  </div>

  <div class="st-drawer-footer show-border">
    <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">Cancelar</button>
    <button [disabled]="selectedEquipments.size === 0"
            (click)="!serviceOrder ? asignEquipmentsToService() : asignEquipmentsToServiceOrder()"
            class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
      <app-st-icon style="margin-right: 8px" *ngIf="asignLoading" name="progress_activity"></app-st-icon>
      <span>Asignar equipos</span>
    </button>
  </div>
</div>
